import React from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/todo-list';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';

/*******************************/

// success view
const toDoListWidgetSuccess = ( props ) => {
    return (
        <div className='ui-to-do-list-widget'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
            />
        </div>
    );
};

// set display name
toDoListWidgetSuccess.displayName = 'toDoListWidgetSuccess';

// set default props
toDoListWidgetSuccess.defaultProps = {
   componentData: {},
   layoutConfig: {},
   onActionClick: noop,
};

// prop types
toDoListWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
export const toDoListWidgetPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-to-do-list-widget-preloader', props.className );

    return (
        <div className={ widgetClassName }>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
toDoListWidgetPreloader.displayName = 'toDoListWidgetPreloader';

// set default props
toDoListWidgetPreloader.defaultProps = {};

// prop types
toDoListWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { toDoListWidget as ToDoListWidget } from 'ui/views/widgets/toDoListWidget';
 *
 * // render
 * <ToDoListWidget propName='propValue'/>
 */
export const toDoListWidget = withNetworkState( toDoListWidgetPreloader, toDoListWidgetSuccess );
